module.exports = __webpack_public_path__ + "img/fl1.3edd8a38.png";